import { createTheme } from "@mui/material";

// MUI theme for insights
export const insightsTheme = createTheme({
    typography: {
        fontFamily: "Plus Jakarta Sans, Arial, sans-serif",
        button: {
            textTransform: "none",
            fontWeight: 600,
        },
    },
    palette: {
        primary: {
            main: "#1D2939",
        },
        secondary: {
            main: "#344054",
        },
        background: {
            default: "#E5E7EB",
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: "8px",
                    border: "1px solid #D0D5DD",
                    boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                    color: "#344054",
                    backgroundColor: "transparent",
                    fontFamily: "'Plus Jakarta Sans', Arial, sans-serif",
                    fontSize: "14px",
                    fontWeight: 600,
                    textTransform: "none",
                    transition: "none",
                    "&:hover": {
                        border: "1px solid #D0D5DD",
                        backgroundColor: "#D0D5DD",
                    },
                    "&.selected": {
                        color: "#1D2939",
                        backgroundColor: "#EAFAFB",
                    },
                },
            },
        },
        MuiButtonGroup: {
            styleOverrides: {
                root: {
                    borderRadius: "8px",
                },
            },
        },
    },
});